import { query, request } from '@/utils/request';
import { DEBUG } from './debug';

const debug = false;
// 获取人员列表数据
export async function getPersonList(params) {
  if (debug) {
    return DEBUG['getPersonList'];
  }
  return request('/zlb/operation/operator/page', {
    method: 'get',
    params,
  });
}

// 获取人员详情--脱敏
export async function getPersonDesensitizeDetail(params) {
  if (debug) {
    return DEBUG['getPersonDesensitizeDetail'];
  }
  return request('/zlb/operation/operator/detail', {
    method: 'get',
    params,
  });
}

// 获取人员详情--不脱敏
export async function getPersonDetail(params) {
  if (debug) {
    return DEBUG['getPersonDetail'];
  }
  return request('/zlb/operation/operator/detail/desensitization', {
    method: 'get',
    params,
  });
}

// 用户管理页-获取人员详情--脱敏
export async function getUserSearchPersonDesensitizeDetail(params) {
  return request('/zlb/operation/operator/user-search/detail', {
    method: 'get',
    params,
  });
}

// 用户管理页-获取人员详情--不脱敏
export async function getUserSearchPersonDetail(params) {
  return request('/zlb/operation/operator/user-search/detail/desensitization', {
    method: 'get',
    params,
  });
}

// 单位列表查询
export const listOrgClueParent = params => {
  return request('/api/zlbuser/institution/by/dataRule', {
    params,
  });
};

// 删除人员的部门任职信息
export async function deletePositionInfo(data) {
  return request('/zlb/operation/operator/department/del', {
    method: 'POST',
    data,
  });
}
// 修改人员的部门任职信息
export async function modifyPositionInfo(data) {
  return request('/zlb/operation/operator/department/modify', {
    method: 'POST',
    data,
  });
}
// 修改人员的部门任职信息
export async function modifyInfo(data) {
  return request('/zlb/operation/operator/modify', {
    method: 'POST',
    data,
  });
}
// 修改用户的启停状态
export async function switchStatus(data) {
  return request('/zlb/operation/operator/status/switch', {
    method: 'POST',
    data,
  });
}
// 获取成员的任职信息列表
export async function getDepartmentList(params) {
  return request('/zlb/operation/operator/department/list', {
    method: 'get',
    params,
  });
}

// 创建新任职信息（添加到新部门
export async function addDepPosition(data) {
  return request('/zlb/operation/operator/department/add', {
    method: 'POST',
    data,
  });
}

// 查询嘉兴公安配置信息
export async function getUserTypeList(params) {
  return query('/api/zlbuser/institution/jxgaUserTypeCode', {
    params,
  });
}
